import { Button, Text } from '@/ui-kit'
import CheckBox from '@/ui-kit/components/Checkbox'
import { useState } from 'react'
import { toast } from 'sonner'
import { useEnrollInProject } from '../api'
import { NectarProject } from '../api/models'
import { MissionProjectHeader } from './MissionProjectHeader'

export const EnrollmentContent = ({ project }: { project: NectarProject }) => {
  const { mutate: enroll, isPending: isEnrolling } = useEnrollInProject()
  const [rulesAccepted, setRulesAccepted] = useState(false)

  const handleEnroll = () => {
    enroll(
      { projectId: project.id, acceptRules: rulesAccepted ? true : undefined },
      {
        onError: () => {
          toast.error('Failed to enroll in project')
        }
      }
    )
  }

  const canEnroll = !project.rules || rulesAccepted

  return (
    <div className="flex flex-col">
      <MissionProjectHeader project={project} />
      <div className="flex max-w-[845px] flex-col gap-6 border-b border-solid border-gray-100 py-6">
        {project.rules && (
          <div className="flex flex-col gap-4">
            <Text type="subtitle-semibold" className="text-gray-70">
              Mission Rules
            </Text>
            <div className="text-gray-80 whitespace-pre-wrap leading-7">{project.rules}</div>
          </div>
        )}
      </div>
      <div className="flex max-w-[845px] flex-col gap-6 py-6">
        <CheckBox
          defaultChecked={rulesAccepted}
          onChange={(value) => setRulesAccepted(Boolean(value))}
          className="text-gray-80"
          label="Accept these rules"
        />
        <Button className="max-w-[300px] max-mobile:w-full max-mobile:max-w-full" onClick={handleEnroll} isDisabled={!canEnroll || isEnrolling}>
          {isEnrolling ? 'Enrolling...' : project.rules ? 'Accept & Start' : 'Start'}
        </Button>
      </div>
    </div>
  )
}
